module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('userprofile', {
    attrs: {
      "user": _vm.user
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bb424c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/profileWrapper.vue
// module id = 485
// module chunks = 1